// @ts-nocheck

class ReviewsCarousel {
  constructor() {
    this.setupEvents();
  }

  setupEvents() {
    document.addEventListener('click', (e) => this.onArrowClick(e));
  }

  onArrowClick(e) {
    const prevBtn = e.target.closest('[data-reviews-prev]');
    const nextBtn = e.target.closest('[data-reviews-next]');
    if (!prevBtn && !nextBtn) return;

    const rootEl = e.target.closest('[data-reviews-carousel]');
    const trackEl = rootEl && rootEl.querySelector('[data-reviews-track]');
    if (!trackEl) return;

    this.scrollTrack(trackEl, nextBtn ? 1 : -1);
  }

  scrollTrack(trackEl, direction) {
    const slideEls = trackEl.children;
    const maxScroll = trackEl.scrollWidth - trackEl.clientWidth;
    if (slideEls.length < 2 || maxScroll <= 1) return;

    const stepSize = slideEls[1].offsetLeft - slideEls[0].offsetLeft;
    const isAtStart = trackEl.scrollLeft <= 1;
    const isAtEnd = trackEl.scrollLeft >= maxScroll - 1;

    let targetLeft = trackEl.scrollLeft + direction * stepSize;
    if (direction > 0 && isAtEnd) targetLeft = 0;
    if (direction < 0 && isAtStart) targetLeft = maxScroll;

    trackEl.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }
}

new ReviewsCarousel();
